import { useLocalStorage } from '@fortress-technology-solutions/fortress-component-library/hooks';

const useEnableFormStateLogging = () => {
  const { localStorageState: isFormStateLoggingEnabled, setLocalStorage } =
    useLocalStorage('formStateLogging', 'boolean', false);

  return {
    isFormStateLoggingEnabled,
    toggleIsFormStateLoggingEnabled: () =>
      setLocalStorage(!isFormStateLoggingEnabled),
  };
};

export default useEnableFormStateLogging;
